<form #PasswordResetForm="ngForm" autocomplete="off" (submit)="submit()">
  <div class="m-auto">
    <div class="p-grid">
      <div class="p-col-12">
        <h3 class="title">Need/Reset Password</h3>
      </div>
      <div class="p-col-12">
        <label for="username">Email Address</label>
        <input class="form-control" name="username" type="text" [(ngModel)]="username" pInputText email
          required>
        </div>
        <div class="p-col-12">
          <p-button type="button" severity="success"label="Submit" (click)="submit()" [disabled]="loading"></p-button>
        </div>
        <div class="p-col-12">
          @if (responseMessage) {
            <p-message [severity]="success ? 'success' : 'error'" [text]="responseMessage">
            </p-message>
          }
        </div>
      </div>
    </div>
  </form> 